// @ts-nocheck TODO

import {html, nothing} from "lit";
import {customElement, property} from "lit/decorators.js";
import {classMap} from "lit/directives/class-map.js";
import UI_MODES from "../ui_modes.js";

import "../../common/CitationButton.js";
import "./AnnotationMenu.js";
import {MobxLitElement} from "@adobe/lit-mobx";

@customElement("pn-annotation-footer")
export class AnnotationFooter extends MobxLitElement {
	@property() annotation = {
		type:       "",
		ai:         false,
		renderable: true,
		pageData:   null
	};
	@property({type: Boolean}) isEditable = false;
	@property() mode;
	@property() onClickPageLink = () => {};

	@property({type: Boolean}) unrenderable = "renderable" in this.annotation && !this.annotation.renderable;

	protected createRenderRoot(): HTMLElement | DocumentFragment {
		return this;
	}

	isBookmark() {
		return this.annotation.type === "bookmark";
	}

	isHighlight() {
		return this.annotation.type === "highlight";
	}

	getCitationButton() {
		const showCitationButton = this.isHighlight() || (!this.isBookmark() && this.annotation.ai);

		if (showCitationButton) {
			return html`
				<pn-citation-button
					.annotation="${this.annotation}"
					.disabled="${this.mode === UI_MODES.SIDEBAR_DRAG}"
					.isEditable="${this.isEditable}"
				></pn-citation-button>
			`;
		} else
			return null;
	}

	getBookmarkIcon() {
		if (this.isBookmark()) {
			return html`
				<i class="icon-bookmark-solid icon-mask" />
			`;
		} else
			return null;
	}

	getUnrenderableIcon() {
		// TODO
		if (this.isHighlight && this.unrenderable) {
			return html`
				<IconButton
					aria-label="Unable to show highlight"
					class="aa-tt-unrenderable js-aa-tt-unrenderable"
					icon="icon-warning icon-mask"
					.tippyOptions=${{
						forceSticky: true,
						placement:   "bottom"
					}}
					tooltipText=${"Page has changed - this highlight cannot be shown."}
				/>
			`;
		} else
			return null;
	}

	getBookmarkLink() {
		if (this.annotation.pageData) {
			if (this.mode === UI_MODES.SIDEBAR_DRAG) {
				return html`
					<span
						class=${classMap({
							"page-title":       true,
							"js-aa-page-title": true
						})}
					>
						${this.annotation.pageData.pageTitle}
					</span>
				`;
			} else {
				return html`
					<a
						class=${classMap({
							"aa-link":          true,
							"page-title":       true,
							"js-aa-page-title": true,
							"has-warning":      this.isHighlight() && this.unrenderable
						})}
						href=${this.annotation.pageData.pageUrl}
						lang=""
						@click=${() => this.onClickPageLink(event, this.annotation.uuid)}
						target="_blank"
					>
						${this.annotation.pageData.pageTitle}
					</a>
				`;
			}
		} else
			return null;
	}

	render() {
		return html`
			<div class="${classMap({
				"footer":            true,
				"mode-sidebar-drag": this.mode === UI_MODES.SIDEBAR_DRAG
			})}">
				${this.getCitationButton()}

				${this.getBookmarkIcon()}

				${this.getUnrenderableIcon()}

				${this.getBookmarkLink()}

				<!-- <div class="js-aa-annotation-comment aa-annotation-comment"></div> -->
			</div>

			${this.isEditable ? html`<pn-annotation-menu
				annotationUuid=${this.annotation.uuid}
			></pn-annotation-menu>`
			: nothing}
		`;
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-annotation-footer": AnnotationFooter;
	}
}
